// Listings run as the acting user through the org Service Account, so results
// already respect that user's Drive access. Names and links are untrusted;
// render as text and only in an href, never as markup.

import { isString } from "../utils/schemaUtils";

export interface DriveFileItem {
  id: string;
  name: string;
  mimeType: string;
  modifiedTime: string;
  webViewLink: string;
  isFolder: boolean;
}

export interface DriveFileListPayload {
  type: "drive_file_list";
  // The search query or parent folder id that produced the listing.
  context: string;
  files: DriveFileItem[];
}

const isDriveFileItem = (v: unknown): v is DriveFileItem => {
  if (!v || typeof v !== "object") return false;
  const r = v as Record<string, unknown>;
  return (
    isString(r.id) &&
    isString(r.name) &&
    isString(r.mimeType) &&
    isString(r.modifiedTime) &&
    isString(r.webViewLink) &&
    typeof r.isFolder === "boolean"
  );
};

export const parseDriveFileListPayload = (v: unknown): DriveFileListPayload | null => {
  if (!v || typeof v !== "object") return null;
  const r = v as Record<string, unknown>;
  if (r.type !== "drive_file_list") return null;
  if (!isString(r.context)) return null;
  if (!Array.isArray(r.files) || !r.files.every(isDriveFileItem)) return null;
  return {
    type: "drive_file_list",
    context: r.context,
    files: r.files,
  };
};
